export const i18n = {
  defaultLocale: "en",
  locales: ["en", "ru"]
} as const;

export const availableLocales: {code: Locale; name: string}[] = [
  {code: "en", name: "English"},
  // Add other supported locales here, for example:
  {code: "ru", name: "Русский"}
  // { code: 'de', name: 'Deutsch' },
];

export type Locale = (typeof i18n)["locales"][number];
